import { Alert } from 'antd';
import React from 'react';
import { PaymentLineGroup } from '../../../../../core-module/services/payments/types';
import {formatDateString, formatPrice, getCalculationFromPaymentLine, getLabelsFromPaymentLine} from '../helpers';
import { PaymentLineComponent } from './PaymentLineComponent';

interface Props {
  paymentLineGroup: PaymentLineGroup;
}

const PaymentLineGroupComponent: React.FC<Props> = ({ paymentLineGroup }) => {
  return (
    <div style={{ marginBottom: 10 }}>
      <h4>
        {paymentLineGroup.route.name} - Gereden op:{' '}
        {formatDateString(paymentLineGroup.route.actualDateDriven)}
      </h4>

      <ul>
        {paymentLineGroup.paymentLines.map((line, index) => (
          <li key={index}>
            <PaymentLineComponent
              name={line.displayName}
              labels={getLabelsFromPaymentLine(line)}
              calculation={getCalculationFromPaymentLine(line)}
            />
          </li>
        ))}
        <li>
          <PaymentLineComponent
            name='Totale vergoeding'
            calculation={formatPrice(paymentLineGroup.totalAmount)}
          />
        </li>
      </ul>

      {paymentLineGroup.route.comments && (
        <Alert
          style={{ marginBottom: 20 }}
          message='Opmerking: '
          description={paymentLineGroup.route.comments}
          type='info'
        />
      )}
    </div>
  );
};

export { PaymentLineGroupComponent };
